'use client'

import React from 'react'

import { ActiveLawContext } from './context'

export function useActiveLaw(): string {
    return React.use(ActiveLawContext)
}
